
<template>
  <div  >

    <div>
<b-modal 
  ref="draggableModal"
  v-model="chatPopup"
  hide-footer
  title=""
  :dialog-class="'draggable-modal'"
  no-close-on-backdrop
  no-close-on-esc
  @shown="onModalShown"
>
  <template #modal-title>
    <div class="d-flex justify-content-between align-items-center w-100">
      <div
        class="custom-modal-title"
        @mousedown="startDrag"
      >
       {{language[219]['GROUP CHAT']}}
      </div>
    
    </div>
  </template>

  <!-- CHAT CONTENT -->
  <div class="chat-messages" style="max-height: 320px; overflow-y: auto; margin-top: -20px;">
    <div
      v-for="msg in messages"
      :key="msg.id"
      :style="{ textAlign: msg.from_user_id == userid ? 'right' : 'left' }"
    >
      <span class="message-bubble" :class="{ highlight: msg.message.includes(`@${currentUsername}`) }">
        <strong>{{ msg.username }}:</strong> {{ msg.message }}
      </span>
    </div>
    <div ref="bottomOfMessages"></div>
  </div>

  <b-form @submit.prevent="sendMessage">
    <div style="position: relative;">
      <b-form-textarea
        v-model="newMessage"
        rows="2"
        @input="handleMentionInput"
        @keydown.enter.exact.prevent="sendMessage"
        @keydown.enter.shift="insertNewLine"
        ref="textarea"
      />
      <div v-if="mentionListVisible" class="mention-dropdown">
        <div
          class="mention-item"
          v-for="user in mentionCandidates"
          :key="user.id"
          @click="selectMention(user.username)"
        >
          {{ user.username }}
        </div>
      </div>
    </div>
    <button type="submit" class="mr-1 btn btn-outline-primary mb-1 font-size_def bdr-rad mt-1">{{language[220]['Send']}}</button>
  </b-form>
</b-modal>


</div>



<nav class="navbar navbar-expand-lg ">
    <div style="padding-left: 0px;" class="container-fluid ">

<div class="navbar-nav">
         


<div  @mouseleave="my1">
       
  <div>
    <!-- Menu Button -->
    <a
      @mouseenter="my1"
      @click="my1"
      ref="myButton"
      v-b-toggle.sidebar-1
      type="button"
      class="nav-link"
      id="navbarDropdownMenuLink"
      role="button"
    >
      <span class="menu1">{{ language[0]['Menu'] }}</span>
    </a>
</div>
    <!-- Chat Icon -->
   





    <b-sidebar  bg-variant="primary"  id="sidebar-1" title="amila"  shadow>
<template #title >
    <!-- Custom title content -->
    <img style="padding-left: 5px;"  src="./../../public/img/evenware-logo.jpg" width="200px" alt="Evenware Logo">
  </template>
    <div >
  <br>
    <ul  class="list-unstyled ps-0">
      <li class="mb-1 bodr1" v-if="hasPermission('/admin/overview')">

        

           <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/admin/overview"><b> {{language[136]['Dashboard']}}</b></router-link></a>

      </li>

      <li class="mb-1 bodr1" v-if="hasAnyPermission(['/mcustomer/index', '/menduser/index', '/issuetracking/index', '/issuetracking/create', '/crm/index', '/crm/create', '/questions/index'])">
        <a  type="button"  v-b-toggle.custmer class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b>{{language[139]['Customer']}}</b></span></a>
        <b-collapse class="mrgin1" id="custmer">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                    <li v-if="hasPermission('/mcustomer/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/mcustomer/index"><b> {{language[140]['Manage Customer']}}</b></router-link></a>
                    </li>
                    <li v-if="hasPermission('/menduser/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/menduser/index"><b> {{language[141]['Manage End User']}}</b></router-link></a>
                    </li>


                    <li  >
        <a  type="button"  v-b-toggle.issue2 class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b> {{language[3]['Issue Tracking']}}</b></span></a>
        <b-collapse class="mrgin1" id="issue2">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                    <li v-if="hasPermission('/issuetracking/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/issuetracking/index"><b>  {{language[4]['Manage Issue']}}</b></router-link></a>
                    </li>
                    <li v-if="hasPermission('/issuetracking/create')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/issuetracking/create"><b> {{language[102]['Create Issue']}}</b> </router-link></a>
                    </li>



          </ul>
        </b-collapse>

      </li>



      <li  >
        <a  type="button"  v-b-toggle.crmnote class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b> {{language[38]['CRM Note']}}</b></span></a>
        <b-collapse class="mrgin1" id="crmnote">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                    <li v-if="hasPermission('/crm/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/crm/index"><b>{{language[142]['Manage CRM Notes']}}</b></router-link></a>
                    </li>
                    <li v-if="hasPermission('/crm/create')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/crm/create"><b> {{language[143]['Skapa CRM-anteckningar']}}</b></router-link></a>
                    </li>



          </ul>
        </b-collapse>

      </li>

       <li v-if="hasPermission('/questions/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/questions/index"><b>Feedback </b> </router-link></a>
                    </li>




          </ul>
        </b-collapse>

      </li>

      <li class="mb-1 bodr1" v-if="hasAnyPermission(['/fuel/create', '/fuel/index', '/timesheet/index', '/timesheet/create', '/roster/index', '/roster/create', '/logbook/index'])">
        <a  type="button"  v-b-toggle.employee class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b>{{language[215]['Employee']}}</b></span></a>
        <b-collapse class="mrgin1" id="employee">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">


             <li  >
        <a  type="button"  v-b-toggle.fuel2 class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b> Expenses</b></span></a>
        <b-collapse class="mrgin1" id="fuel2">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                    <li v-if="hasPermission('/fuel/create')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/fuel/create"><b>  {{language[222]['Fuel Bill']}}</b></router-link></a>
                    </li>
                    <li v-if="hasPermission('/fuel/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/fuel/index"><b>  Expenses</b> </router-link></a>
                    </li>
                  



          </ul>
        </b-collapse>

      </li>

        <li  >
        <a  type="button"  v-b-toggle.issue2 class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b> {{language[216]['Timesheet']}}</b></span></a>
        <b-collapse class="mrgin1" id="issue2">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                    <li v-if="hasPermission('/timesheet/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/timesheet/index"><b> {{language[223]['Timesheet Management']}}</b></router-link></a>
                    </li>
                    <li v-if="hasPermission('/timesheet/create')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/timesheet/create"><b>  {{language[224]['Create Timesheet']}}</b> </router-link></a>
                    </li>



          </ul>
        </b-collapse>

      </li>


      
      

       <li >
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/logbook/index"><b>  Logbook</b></router-link></a>
                    </li>

                      <li  >
        <a  type="button"  v-b-toggle.training class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b> Training</b></span></a>
        <b-collapse class="mrgin1" id="training">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                    <li >
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/training/index"><b> Trainers</b></router-link></a>
                    </li>
                    <li >
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/tinternalcourses/index"><b> Internal Courses</b></router-link></a>
                    </li>
                    <li >
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/tinternalcourses/dashboard"><b> Training Dashboard</b></router-link></a>
                    </li>
                    <li >
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/tinternalcourses/scheduled"><b> Scheduled Internal Courses</b></router-link></a>
                    </li>
                    <li >
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/tinternalcourses/employee-training-requirement"><b> Employee Training Requirement</b></router-link></a>
                    </li>




          </ul>
        </b-collapse>

      </li>
       <li  >
        <a  type="button"  v-b-toggle.job4 class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b> Learning</b></span></a>
        <b-collapse class="mrgin1" id="job4">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                    
                    <li >
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/job/desindex"><b> Manage Job Descriptions</b></router-link></a>
                    </li>
                    <li >
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/job/index"><b> Manage Learning</b></router-link></a>
                    </li>
                  

          </ul>
          </b-collapse>
          </li>



<li  v-if="hasAnyPermission(['/roster/index', '/roster/create'])">
        <a type="button" v-b-toggle.roster class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2"><b>Roster</b></span></a>
        <b-collapse class="mrgin1" id="roster">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
            <li v-if="hasPermission('/roster/index')">
              <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/roster/index"><b>Manage Schedule Roster</b></router-link></a>
            </li>
            <li v-if="hasPermission('/roster/create')">
              <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/roster/actual/index"><b>Manage Actual Roster</b></router-link></a>
            </li>
            <li v-if="hasAnyPermission(['/roster/ai/index', '/roster/index'])">
              <a type="button" v-b-toggle.ai-roster class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2"><b>AI Roster</b></span></a>
              <b-collapse class="mrgin1" id="ai-roster">
                <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                  <li v-if="hasAnyPermission(['/roster/ai/index', '/roster/index'])">
                    <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/roster/ai/index"><b>Manage AI Schedule Roster</b></router-link></a>
                  </li>
                  <li v-if="hasAnyPermission(['/roster/ai/index', '/roster/index', '/roster/create'])">
                    <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/roster/ai/actual/index"><b>Manage AI Actual Roster</b></router-link></a>
                  </li>

                </ul>
              </b-collapse>
            </li>
          </ul>
        </b-collapse>
      </li>
       

        </ul>
        </b-collapse>
        </li>

       <li v-if="hasPermission('/document/index')" class="mb-1 bodr1">
        <a  type="button"  v-b-toggle.document class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b>Documents</b></span></a>
        <b-collapse class="mrgin1" id="document">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                    <li v-if="hasPermission('/document/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/document/index"><b>Manage Documents</b></router-link></a>
                    </li>

                    </ul>
                    </b-collapse>

       </li>




      <li class="mb-1 bodr1" v-if="hasAnyPermission(['/mproduct/index', '/inventory/index', '/quotation/index', '/ssalesorder/index', '/ssalesorder/indexcon', '/igrn/indexreturn', '/igrn/createreturn', '/gin/index', '/gin/indexcon', '/sinvoice/index', '/quotation/pos', '/tcreditnotes/index', '/spaymentreceipts/index', '/spaymentreceipts/pdindex', '/gin/indexadjust'])">
        <a  type="button"  v-b-toggle.sales class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b>Product Sales</b></span></a>
        <b-collapse class="mrgin1" id="sales">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                    <li v-if="hasPermission('/mproduct/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/mproduct/index"><b> {{language[144]['Manage Products']}}</b></router-link></a>
                    </li>
                    <li v-if="hasPermission('/inventory/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/inventory/index"><b> Product Inventory</b></router-link></a>
                    </li>
                    <li v-if="hasPermission('/quotation/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/quotation/index"><b> {{language[146]['Manage Quotations']}}</b></router-link></a>
                    </li>
        <a  type="button"  v-b-toggle.sales1 class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b>{{language[147]['Sales']}}</b> </span></a>
        <b-collapse class="mrgin1" id="sales1">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                    <li v-if="hasPermission('/ssalesorder/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/ssalesorder/index"><b> {{language[148]['Manage Sales Order']}}</b></router-link></a>
                    </li>
                    <li v-if="hasPermission('/ssalesorder/indexcon')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/ssalesorder/indexcon"><b> {{language[149]['Manage Consignment Sales Order']}}</b></router-link></a>
                    </li>
                    <a  type="button"  v-b-toggle.cusret class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b> {{language[150]['Manage Customer Return']}}</b> </span></a>
        <b-collapse class="mrgin1" id="cusret">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                    <li v-if="hasPermission('/igrn/indexreturn')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/igrn/indexreturn"><b>{{language[150]['Manage Customer Return']}}</b></router-link></a>
                    </li>
                    <li v-if="hasPermission('/igrn/createreturn')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/igrn/createreturn"><b>{{language[151]['Create Customer Return']}}</b></router-link></a>
                    </li>


          </ul>
        </b-collapse>

          </ul>
        </b-collapse>

        <a  type="button"  v-b-toggle.gin2 class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" > <b> Product GIN</b></span></a>
        <b-collapse class="mrgin1" id="gin2">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                    <li v-if="hasPermission('/gin/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/gin/index"><b> Manage Product GIN</b></router-link></a>
                    </li>
                    <li v-if="hasPermission('/gin/indexcon')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/gin/indexcon"><b> Manage Product Consignment GIN</b></router-link></a>
                    </li>


          </ul>
        </b-collapse>

        <a  type="button"  v-b-toggle.sinvoice1 class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" > <b> {{language[154]['Invoice']}}</b></span></a>
        <b-collapse class="mrgin1" id="sinvoice1">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                    <li v-if="hasPermission('/sinvoice/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/sinvoice/index"><b>{{language[155]['Manage Invoice']}}</b></router-link></a>
                    </li>
                    <li v-if="hasPermission('/quotation/pos')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/quotation/pos"><b>POS </b></router-link></a>
                    </li>
                    <li v-if="hasPermission('/tcreditnotes/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/tcreditnotes/index"><b> {{language[156]['Manage Credit Notes']}}</b></router-link></a>
                    </li>


          </ul>
        </b-collapse>

        <a  type="button"  v-b-toggle.receipt1 class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b> Product Receipts</b> </span></a>
        <b-collapse class="mrgin1" id="receipt1">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                    <li v-if="hasPermission('/spaymentreceipts/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/spaymentreceipts/index"><b> {{language[158]['Manage Receipts']}}</b></router-link></a>
                    </li>
                    <li v-if="hasPermission('/spaymentreceipts/pdindex')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/spaymentreceipts/pdindex"><b> {{language[159]['Manage PD receipts']}}</b></router-link></a>
                    </li>


          </ul>
        </b-collapse>



                    <li v-if="hasPermission('/gin/indexadjust')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/gin/indexadjust"><b> {{language[160]['Manage Stock Adjustment']}}</b></router-link></a>
                    </li>
                    <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b> {{language[161]['Reports']}}</b></router-link></a>
                    </li>

          </ul>
        </b-collapse>

      </li>



      <li v-if="hasPermission('/dproduct/index')" class="mb-1 bodr1">
        <a  type="button"  v-b-toggle.distri class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b>Distribution</b></span></a>
        <b-collapse class="mrgin1" id="distri">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                    <li >
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/dproduct/index"><b> Manage Product</b></router-link></a>
                    </li>
                    <li >
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/dinventory/index"><b> Manage Inventory</b></router-link></a>
                    </li>
                    <li >
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/dsales/index"><b> Manage Sales Order</b></router-link></a>
                    </li>
                    <li >
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/dgin/index"><b> Manage GIN</b></router-link></a>
                    </li>
                    <li >
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/dinvoice/index"><b> Manage Invoice</b></router-link></a>
                    </li>
                    <li >
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/dreceipt/index"><b> Manage Receipt</b></router-link></a>
                    </li>

          </ul>
        </b-collapse>

      </li>





       <li class="mb-1 bodr1" v-if="hasAnyPermission(['/mmodels/index', '/vinventory/index', '/idealerassignvehicle/index', '/sopportunity/index', '/spfi/index', '/svehiclesalesorder/index', '/vehiclesgin/index', '/svehicleinvoice/index', '/svehiclesalesreceipt/index'])">
        <a  type="button"  v-b-toggle.rental class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b>Vehicle Sales</b></span></a>
        <b-collapse class="mrgin1" id="rental">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                    <li v-if="hasPermission('/mmodels/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/mmodels/index"><b> {{language[169]['Manage Vehicles']}}</b></router-link></a>
                    </li>
                    <li>
                      <a  type="button"  v-b-toggle.rentalinv class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b> {{language[170]['Vehicle Inventory']}}</b></span></a>
        <b-collapse class="mrgin1" id="rentalinv">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                   <li v-if="hasPermission('/vinventory/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/vinventory/index"><b> {{language[171]['Manage Vehicle Inventory']}}</b></router-link></a>
                    </li>
                   <li v-if="hasPermission('/idealerassignvehicle/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/idealerassignvehicle/index"><b> {{language[172]['Manage Allocated Vehicles']}}</b></router-link></a>
                    </li>
                   <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b> {{language[173]['Manage SO Vehicles']}}</b></router-link></a>
                    </li>
                   <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b> {{language[174]['Manage Invoiced Vehicles']}}</b></router-link></a>
                    </li>

          </ul>
        </b-collapse>
                    </li>
      <li>
        <a  type="button"  v-b-toggle.salesvehic class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b> {{language[147]['Sales']}}</b></span></a>
        <b-collapse class="mrgin1" id="salesvehic">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                   <li v-if="hasPermission('/sopportunity/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/sopportunity/index"><b> {{language[175]['Manage Sales Contact Report']}}</b></router-link></a>
                    </li>
                   <li v-if="hasPermission('/spfi/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/spfi/index"><b> {{language[176]['Manage Proforma Invoice']}}</b></router-link></a>
                    </li>
                   <li v-if="hasPermission('/svehiclesalesorder/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/svehiclesalesorder/index"><b> {{language[177]['Manage Vehicle Sales Order']}}</b></router-link></a>
                    </li>


          </ul>
        </b-collapse>
      </li>
      <li>
        <a  type="button"  v-b-toggle.ginvehic class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b>{{language[178]['Vehicle']}} GIN</b></span></a>
        <b-collapse class="mrgin1" id="ginvehic">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                   <li v-if="hasPermission('/vehiclesgin/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/vehiclesgin/index"><b>{{language[169]['Manage Vehicles']}} GIN</b></router-link></a>
                    </li>
                   <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b>{{language[179]['Manage Inter Dealer Transfer ']}}</b></router-link></a>
                    </li>
                   <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b>  {{language[180]['Manage']}} MTA2</b></router-link></a>
                    </li>


          </ul>
        </b-collapse>
      </li>
                    <li v-if="hasPermission('/svehicleinvoice/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/svehicleinvoice/index"><b> {{language[181]['Manage Vehicle Invoice']}}</b></router-link></a>
                    </li>
                    <li v-if="hasPermission('/svehiclesalesreceipt/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/svehiclesalesreceipt/index"><b> {{language[182]['Manage Vehicle Receipts']}}</b></router-link></a>
                    </li>
                    <li>
        <a  type="button"  v-b-toggle.othervehic class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b> {{language[183]['Other Charges']}}</b></span></a>
        <b-collapse class="mrgin1" id="othervehic">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                   <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b> {{language[184]['Deduct Additional Charges']}}</b></router-link></a>
                    </li>
                   <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b> {{language[185]['Manage Dealer Commission Voucher']}}</b></router-link></a>
                    </li>
                   <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b> {{language[186]['Manage Broker Commission Voucher']}}</b></router-link></a>
                    </li>
                   <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b> {{language[187]['Manage Registration Payment Voucher']}}</b></router-link></a>
                    </li>
                   <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b> {{language[188]['Manage Transportation Payment Voucher']}}</b></router-link></a>
                    </li>
                   <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b> {{language[189]['Manage Insuarance Payment Voucher']}}</b></router-link></a>
                    </li>


          </ul>
        </b-collapse>
      </li>



                    <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b> {{language[161]['Reports']}}</b></router-link></a>
                    </li>



          </ul>
        </b-collapse>

      </li>

      <li class="mb-1 bodr1" v-if="hasAnyPermission(['/msupplier/index', '/cpurchasing/index', '/cgrn/index'])">
        <a  type="button"  v-b-toggle.purchasing class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b>{{language[218]['Purchasing']}}</b></span></a>
        <b-collapse class="mrgin1" id="purchasing">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                    <li v-if="hasPermission('/msupplier/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/msupplier/index"><b> {{language[226]['Manage Supplier']}}</b></router-link></a>
                    </li>
                    <li v-if="hasPermission('/cpurchasing/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/cpurchasing/index"><b> {{language[227]['Manage Purchase Order']}}</b></router-link></a>
                    </li>
                    <li v-if="hasPermission('/cgrn/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/cgrn/index"><b>GRN</b></router-link></a>
                    </li>






          </ul>
        </b-collapse>

      </li>




      <li class="mb-1 bodr1" v-if="hasAnyPermission(['/servicecalender/index', '/servicejob/index', '/serviceinvoice/index', '/servicereceipt/index'])">
        <a  type="button"  v-b-toggle.field class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b> Service</b></span></a>
        <b-collapse class="mrgin1" id="field">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                    <li v-if="hasPermission('/servicecalender/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/servicecalender/index"><b> {{language[163]['Manage Service Schedule']}}</b></router-link></a>
                    </li>
                    <li v-if="hasPermission('/servicejob/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/servicejob/index"><b> {{language[164]['Manage Service Jobs']}}</b></router-link></a>
                    </li>
                    <li v-if="hasPermission('/serviceinvoice/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/serviceinvoice/index"><b> {{language[165]['Manage Service Invoices']}}</b></router-link></a>
                    </li>
                    <li v-if="hasPermission('/servicereceipt/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/servicereceipt/index"><b> {{language[166]['Manage Service Receipts']}}</b></router-link></a>
                    </li>

                      <li v-if="hasPermission('/cmmsinventory/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/cmmsinventory/index"><b> Spare Parts</b></router-link></a>
                    </li>

                       <li   >
        <a  type="button"  v-b-toggle.cmmgin2 class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b> Goods Issue Note</b></span></a>
        <b-collapse class="mrgin1" id="cmmgin2">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                 <li v-if="hasPermission('/cmmsgin/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/cmmsgin/index"><b> Manage GIN</b></router-link></a>
                    </li>

                    </ul>
                    </b-collapse>

                    </li>

                  



          </ul>
        </b-collapse>

      </li>

     

      <!-- <li class="mb-1 bodr1"  >
        <a  type="button"  v-b-toggle.inventory class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" >Inventory</span></a>
        <b-collapse class="mrgin1" id="inventory">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                    <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/">Manage Supplier</router-link></a>
                    </li>
                    <li v-if="hasPermission('/mproduct/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/mproduct/index">Manage Product</router-link></a>
                    </li>
                    <li v-if="hasPermission('/inventory/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/inventory/index">Inventory</router-link></a>
                    </li>
                    <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/">Purchase Order</router-link></a>
                    </li>
                    <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/">GRN</router-link></a>
                    </li>
                    <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/">GIN</router-link></a>
                    </li>
                    <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"> Manage Consignment </router-link></a>
                    </li>



          </ul>
        </b-collapse>

      </li> -->

       <li v-if="hasPermission('/rental/calnder')" class="mb-1 bodr1" >
          <a  type="button"  v-b-toggle.rentalmenu class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b> Rental</b></span></a>
          <b-collapse class="mrgin1" id="rentalmenu">
            <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
               <li >
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/rental/calnder"><b>Rental Calendar</b></router-link></a>
                    </li>
                    <li >
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/rental/gin/index"><b>Manage Rental Units</b></router-link></a>
                    </li>
                    <!-- <li >
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/rental/gin/index"><b>Manage Rental GIN</b></router-link></a>
                    </li> -->
                    <!-- <li >
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/rental/gin"><b>Create Rental GIN</b></router-link></a>
                    </li> -->
                    <li >
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/rental/invoice/index"><b>Manage Rental Invoice</b></router-link></a>
                    </li>
                    <li >
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/rental/return/index"><b>Rental Return List</b></router-link></a>
                    </li>
                  
                   
            </ul>
          </b-collapse>
        </li>

       <li class="mb-1 bodr1" v-if="hasAnyPermission(['/cmmsassets/index', '/cmmsservicecalender/index', '/cmmsservicejob/index', '/cmmserviceprevenitvejob/index', '/cmmscrm/index', '/cmmsinventory/index', '/cmmsgin/index'])">
        <a  type="button"  v-b-toggle.cmasset class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b> Assets</b></span></a>
        <b-collapse class="mrgin1" id="cmasset">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                 <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/cmmsassets/excel-index"><b> Assets</b></router-link></a>
                    </li>
                 
                      <li v-if="hasPermission('/cmmsservicecalender/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/cmmsservicecalender/index"><b> Service Schedule</b></router-link></a>
                    </li>
                  <li v-if="hasPermission('/cmmsservicejob/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/cmmsservicejob/index"><b> Repair Jobs</b></router-link></a>
                    </li>
                  <li v-if="hasPermission('/cmmserviceprevenitvejob/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/cmmserviceprevenitvejob/index"><b> Preventive Jobs </b></router-link></a>
                    </li>
                     <li v-if="hasPermission('/cmmscrm/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/cmmscrm/index"><b>Service Notes</b></router-link></a>
                    </li>
                  <li v-if="hasPermission('/cmmsinventory/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/cmmsinventory/index"><b> Spare Parts</b></router-link></a>
                    </li>

                       <li   >
        <a  type="button"  v-b-toggle.cmmgin class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b> Goods Issue Note</b></span></a>
        <b-collapse class="mrgin1" id="cmmgin">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                 <li v-if="hasPermission('/cmmsgin/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/cmmsgin/index"><b> Manage GIN</b></router-link></a>
                    </li>

                    </ul>
                    </b-collapse>

                    </li>






                    



          </ul>
          </b-collapse>
        </li>


   


          <li class="mb-1 bodr1">
        <a v-if="hasAnyPermission(['/projectmanagement/index'])" type="button"  v-b-toggle.project class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b>Projects </b></span></a>
        <b-collapse class="mrgin1" id="project">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                   <li v-if="hasPermission('/projectmanagement/index')" >
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/projectmanagement/dashboard"><b> Dashboard </b></router-link></a>
                    </li>
                   <li v-if="hasPermission('/projectmanagement/index')" >
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/projectmanagement/index"><b> Manage Project </b></router-link></a>
                    </li>
                   <li >
                      <a v-if="hasPermission('/projectmanagement/visitindex')" class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/projectmanagement/visitindex"><b> Visit Reporting</b></router-link></a>
                    </li>
                   
          </ul>
          </b-collapse>
          </li>


      <li  class="mb-1 bodr1" v-if="hasAnyPermission(['/pdf/create7', '/pdf/index2'])">
        <a type="button" v-b-toggle.camo32 class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b>CAMO</b></span></a>
        <b-collapse  class="mrgin1" id="camo32">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                    <!-- <li v-if="hasPermission('/pdf/create')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/pdf/create"><b> Upload File</b></router-link></a>
                    </li> -->
                    <!-- <li v-if="hasPermission('/pdf/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/pdf/index"><b> CAMO </b></router-link></a>
                    </li> -->

                    
                    <li v-if="hasPermission('/pdf/create7')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/pdf/create7"><b> Search </b></router-link></a>
                    </li>
                    <li v-if="hasPermission('/pdf/index2') && (aircraftSavedMenus.length || otherSavedMenus.length)">
                      <a  type="button"  v-b-toggle.camosaveddata class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b> Show Saved Data </b></span></a>
                      <b-collapse class="mrgin1" id="camosaveddata">
                        <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                          <li v-for="aircraftItem in aircraftSavedMenus" :key="'aircraft-' + aircraftItem.value">
                            <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" :to="{ path: '/pdf/index2', query: { aircraft: aircraftItem.aircraft || aircraftItem.value, line: aircraftItem.line || undefined, file: aircraftItem.file || undefined } }"><b>{{ aircraftItem.label }}</b></router-link></a>
                          </li>
                          <li v-if="otherSavedMenus.length">
                            <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" :to="{ path: '/pdf/index2', query: { group: 'other' } }"><b>Other</b></router-link></a>
                          </li>
                        </ul>
                      </b-collapse>
                    </li>
          </ul>
          </b-collapse>
          </li>

      <!-- <li class="mb-1 bodr1">
        <a  type="button"  v-b-toggle.report class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b> {{language[161]['Reports']}}</b></span></a>
        <b-collapse class="mrgin1" id="report">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                    <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b> {{language[190]['Aged Debtors Report']}}</b></router-link></a>
                    </li>
                    <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b>{{language[191]['Sales Report by Customer']}}</b></router-link></a>
                    </li>

                    <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b> {{language[192]['Sales Report by Product']}}</b></router-link></a>
                    </li>
                    <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b> {{language[193]['Invoice List']}}</b></router-link></a>
                    </li>
                    <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b>  GRN {{language[194]['List']}}</b></router-link></a>
                    </li>
                    <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b>GIN {{language[194]['List']}}</b></router-link></a>
                    </li>
                    <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b> {{language[195]['Receipt List']}}</b></router-link></a>
                    </li>
                    <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b> {{language[196]['Advance payment Set Off List']}}</b></router-link></a>
                    </li>
                    <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b> {{language[197]['Sales Return List']}}</b></router-link></a>
                    </li>

                    <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b> {{language[198]['Invoiced Sales Report']}}</b></router-link></a>
                    </li>

                    <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b> {{language[199]['Pending Sales Order List']}}</b></router-link></a>
                    </li>
                    <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b> {{language[200]['Stock to Depreciate']}}</b></router-link></a>
                    </li>



          </ul>
        </b-collapse>

      </li> -->


    



      <li class="mb-1 bodr1" v-if="hasAnyPermission(['/user/index'])">
        <a  type="button"  v-b-toggle.users class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b> {{language[6]['Users']}}</b></span></a>
        <b-collapse class="mrgin1" id="users">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                  <li v-if="hasPermission('/user/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/user/index"><b> {{language[6]['Users']}}</b></router-link></a>
                    </li>
          </ul>
          </b-collapse>
        </li>







      <li class="mb-1 bodr1" v-if="hasAnyPermission(['/setting/index', '/user/visitreport', '/msalespeople/index', '/mservicetechnician/index', '/mserviceadvisor/index', '/chat/index'])">
        <a  type="button"  v-b-toggle.settings class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" ><b> {{language[8]['Settings']}}</b></span></a>
        <b-collapse class="mrgin1" id="settings">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                   <li v-if="hasPermission('/setting/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/setting/index"><b>{{language[9]['Manage Language']}}</b> </router-link></a>
                    </li>
                    <li v-if="hasPermission('/user/visitreport')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/user/visitreport"><b>User Tracking Report</b></router-link></a>
                    </li>
                    <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b> {{language[201]['Manage Product Line']}}</b> </router-link></a>
                    </li>
                    <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b> {{language[202]['Manage Currencies Lists']}}</b></router-link></a>
                    </li>
                    <li v-if="hasPermission('/msalespeople/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/msalespeople/index"><b> {{language[228]['	Manage Sales Executive']}}</b></router-link></a>
                    </li>
                    <li v-if="hasPermission('/mservicetechnician/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/mservicetechnician/index"><b> {{language[204]['Manage Service Technician']}}</b></router-link></a>
                    </li>
                      <li v-if="hasPermission('/mservicetechnician/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/mservicetechnician/index"><b> {{language[167]['Manage Service Engineers']}}</b></router-link></a>
                    </li>
                    <li v-if="hasPermission('/mserviceadvisor/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/mserviceadvisor/index"><b> {{language[205]['Manage Service Advisor']}}</b></router-link></a>
                    </li>
                    <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b> {{language[206]['Manage PO Fixed Charges']}}</b></router-link></a>
                    </li>
                    <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b> {{language[207]['Manage Service Visit Charges']}}</b></router-link></a>
                    </li>
                    <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b> {{language[208]['Manage Service Request']}}</b></router-link></a>
                    </li>

                    <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b> {{language[209]['Manage Terms and variations']}}</b></router-link></a>
                    </li>
                    <li v-if="hasAnyPermission(['/roster/index', '/roster/create'])">
                      <a type="button" v-b-toggle.roster-setting class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2"><b>Roster Setting</b></span></a>
                      <b-collapse class="mrgin1" id="roster-setting">
                        <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                          <li>
                            <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/roster/pattern/index"><b>Manage Roster</b></router-link></a>
                          </li>
                          <li>
                            <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/roster/pattern/create"><b>Create Pattern</b></router-link></a>
                          </li>
                        </ul>
                      </b-collapse>
                    </li>
                    <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b> {{language[128]['	User Manual']}}</b></router-link></a>
                    </li>
                    <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/"><b> {{language[210]['Audit Trail']}}</b></router-link></a>
                    </li>
                    <li v-if="hasPermission('/chat/index')">
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/chat/index"><b>{{language[229]['Chat']}}</b></router-link></a>
                    </li>
          </ul>
        </b-collapse>

      </li>







                    


    </ul>
  </div>

    </b-sidebar>


  </div>
 
</div>


<template>
  <div style="margin-right: -15px;"  class="d-flex  justify-content-end flex-wrap top-bar-controls">
    <!-- Logout -->
<div style="margin-right: -5px;">
 <img
      @click="openGroupChat"
      style="cursor: pointer;"
      src="./../../public/img/icons/chat_icon8.png"
      width="52px"
      alt="Evenware Logo"
    />
  </div>
  <!-- Notifications Start-->
 <div class="dropdown ">
  <a
    class="btn btn-link position-relative"
    href="#"
    role="button"
    id="notificationDropdown"
    data-toggle="dropdown"
    aria-expanded="false"
    style="color: #0b4687; font-size: 25px; text-decoration: none;padding: 1px;"
    @click="hideBadge"  
  >
    <i class="fas fa-bell"></i>

    <!-- Badge (show only if not hidden) -->
    <span
      v-if="badgeHidden=='false' && notifications.length > 0"
      class="badge badge-danger position-absolute"
      style="top: -4px; right: -7px; font-size: 12px;"
    >
       {{ notifications.length > 10 ? '10+' : notifications.length }}

    </span>
  </a>

  <!-- Notification Dropdown -->
    <div
    class="dropdown-menu dropdown-menu-right p-2"
    style="min-width: 250px; max-height: 300px; overflow-y: auto; border-radius: 15px;"
    aria-labelledby="notificationDropdown"
  >
    <h6 class="dropdown-header">Notifications</h6>

    <div v-if="notifications.length === 0" class="dropdown-item text-muted">
      No notifications
    </div>

    <a
      v-for="(note, index) in showAllNotifications ? notifications : notifications.slice(0, 10)"
      :key="index"
      href="#"
      class="dropdown-item small"
    >
      {{ note.p_code }} - {{ note.job_category2 }}
      <br />
      <small class="text-muted">{{ note.scheduled_date }}</small>
    </a>

    <div
      v-if="notifications.length > 10 && !showAllNotifications"
      class="dropdown-item text-center text-primary small"
      style="cursor: pointer;"
      @click="showAllNotifications = true"
    >
      More notifications...
    </div>
  </div>
</div>



   <!-- Notifications end -->

    <!-- Language Dropdown -->
    <div class="dropdown">
  <a
    style="background-color: white; color: #0b4687;margin-right: -15px;"
    class="btn dropdown-toggle language-dropdown myboder languagbtn"
    type="button"
    id="dropdownMenuButton1"
    data-toggle="dropdown"
    aria-expanded="false"
  >
    <i class="fa fa-lg fa-globe language-icon "></i>
    {{ selectedLanguageName }}
  </a>
  <ul style="border-radius: 15px;" class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
    <li
      v-for="lang in lans"
      :key="lang.id"
      @click="selectLanguage(lang)"
      class="dropdown-item"
      style="cursor: pointer"
    >
      {{ lang.language_name }}
    </li>
  </ul>
</div>
     <a class="nav-link astylemy " style="margin-bottom: -25px;" href="" @click.prevent="Logout()">
       <img class="ms-3"
      @click="openGroupChat"
      style="cursor: pointer;"
      src="./../../public/img/icons/log-out007.png"
      width="39px"
      alt="Evenware Logo"
    /><br>
      <span  style="font-size: smaller; color: #0b4687;">{{ user }}</span> 
    </a>
  </div>
</template>






    </div>

  </nav>

</div>

</template>
<script>
import authService from '@/auth.service';
import axios from 'axios';
import Notification from '@/components/NotificationPlugin/Notification.vue'
import Notifications from '@/pages/Notifications.vue'

  export default {
  data () {
      return {

        activeNotifications: false,
        language:JSON.parse(authService.isLanguage()),

  languageid:authService.isLanguageid(),
  languagename:authService.isLanguagename(),
  badgeHidden:authService.isBadgehidden(),
  selectedLanguageName: "Select Language",

    access_token: authService.isLoggedIn(),
      userid: authService.isUserid(),
       currentUsername: authService.isUsername(),
      messages: [],
      chatPopup: false,
      newMessage: '',

        mentionListVisible: false,
    mentionQuery: '',
    mentionCandidates: [],
    mentionInsertIndex: null,
    allUsers: [],

 hasBeenCentered: false,


      dragging: false,
    offset: { x: 0, y: 0 },
    modalElement: null,

     isMaximized: false,
    previousStyle: {},
     notifications: [],
    showAllNotifications: false,
  
  lans:[],
      camoSavedMenus: {
        aircraft: [],
        other: []
      },
      }
    },

    computed: {
      routeName () {
        const {name} = this.$route
        return this.capitalizeFirstLetter(name)
      },
      aircraftSavedMenus () {
        return this.camoSavedMenus.aircraft || []
      },
      otherSavedMenus () {
        return this.camoSavedMenus.other || []
      },
      lineSavedMenus () {
        return []
      }
    },
    beforeMount(){
        this.user = authService.isUsername();
      },
      mounted() {
        this.loadlan();
      
        this.loadData();
        this.loadCamoSavedMenus();
      },

        created() {
    this.startMessagePolling();
      this.fetchAllUsers();
  },
    methods: {
 hideBadge() {
  localStorage.setItem('BADGEHIDDEN', true);
    this.badgeHidden = localStorage.getItem('BADGEHIDDEN');   // hide the count forever after first open
  },
      hasPermission(path) {
        return authService.hasPermission(path)
      },
      hasAnyPermission(paths) {
        return paths.some(path => authService.hasPermission(path))
      },
      async loadCamoSavedMenus() {
        if (!this.hasPermission('/pdf/index2')) {
          this.camoSavedMenus = {
            aircraft: [],
            other: []
          }
          return
        }

        try {
          const { data } = await axios.get('/mproduct/getmaintenancenestedmenu')
          this.camoSavedMenus = data && data.success && data.data ? data.data : {
            aircraft: [],
            other: []
          }
        } catch (error) {
          this.camoSavedMenus = {
            aircraft: [],
            other: []
          }
          console.error(error)
        }
      },
     async loadData() {
      console.log("aaaa");
      try {
        const { data } = await axios.post(
          "/cserviceevent/notification",
          {},
          {
            headers: {
              Authorization: "Bearer " + this.access_token,
              "Content-type": "application/json",
            },
          }
        );
        console.log(data);
       this.notifications= data.notifications
      } catch (error) {
        console.error(error);
      }
    },

    onModalShown() {
    this.$nextTick(() => {
      // Important: target the actual .modal-dialog inside
      this.modalElement = document.querySelector('.draggable-modal');

      if (!this.modalElement || this.isMaximized) return;

      const viewportWidth = window.innerWidth;
      const modalRect = this.modalElement.getBoundingClientRect();

     const left = (window.innerWidth - modalRect.width) / 2;
      const top = -75;

      this.modalElement.style.position = 'fixed';
      this.modalElement.style.margin = '0';
      this.modalElement.style.top = `${top}px`;
      this.modalElement.style.left = `${left}px`;
      this.modalElement.style.width = '450px';
      this.modalElement.style.height = 'auto';
    });
  },
  toggleMaximize() {
  if (!this.modalElement) {
    this.modalElement = document.querySelector('.draggable-modal');
  }
  if (!this.modalElement) return;

  if (!this.isMaximized) {
    // Save current position and size
    this.previousStyle = {
      top: this.modalElement.style.top,
      left: this.modalElement.style.left,
      width: this.modalElement.style.width,
      height: this.modalElement.style.height,
      position: this.modalElement.style.position
    };

    // Apply fullscreen
  //  this.modalElement.style.position = 'fixed';
    this.modalElement.style.top = '-50';
    this.modalElement.style.left = '0';
    this.modalElement.style.width =  '45000px';
    this.modalElement.style.height = 'auto';
    this.modalElement.style.margin = '0';

    this.isMaximized = true;
  } else {
    // Restore to previous size
    Object.assign(this.modalElement.style, this.previousStyle);
    this.isMaximized = false;
  }
},
  startDrag(e) {
    if (!this.modalElement || this.isMaximized) return; // Don't drag while maximized
    this.dragging = true;
    const rect = this.modalElement.getBoundingClientRect();
    this.offset = {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    };
    document.addEventListener('mousemove', this.onDrag);
    document.addEventListener('mouseup', this.stopDrag);
  },
  onDrag(e) {
    if (!this.dragging || !this.modalElement || this.isMaximized) return;
    this.modalElement.style.left = `${e.clientX - this.offset.x}px`;
    this.modalElement.style.top = `${e.clientY - this.offset.y}px`;
  },
  stopDrag() {
    this.dragging = false;
    document.removeEventListener('mousemove', this.onDrag);
    document.removeEventListener('mouseup', this.stopDrag);
  },

      scrollToBottom() {
  this.$nextTick(() => {
    setTimeout(() => {
      const bottom = this.$refs.bottomOfMessages;
      if (bottom) {
        bottom.scrollIntoView({ behavior: 'smooth' });
      }
    }, 50); // small delay helps ensure layout is stable
  });
},

      openGroupChat() {
      this.chatPopup = true;
      this.loadMessages();
    },

   async fetchAllUsers() {
  try {
    const { data } = await axios.get('/user/all', {
      headers: {
        'Authorization': 'Bearer ' + this.access_token
      }
    });
    this.allUsers = data;
    console.log("Fetched users:", data); // ✅ should log usernames
  } catch (error) {
    console.error('Failed to fetch users:', error);
  }
},

handleMentionInput() {

 const textarea = this.$refs.textarea && this.$refs.textarea.$el;
  console.log(textarea);
  if (!textarea) return;
 
  const cursorPos = textarea.selectionStart;
  const textBeforeCursor = this.newMessage.slice(0, cursorPos);
  const match = textBeforeCursor.match(/@(\w*)$/);

  console.log("Text before cursor:", textBeforeCursor);
  console.log("Match:", match);

  if (match) {
    this.mentionQuery = match[1];
    this.mentionInsertIndex = textBeforeCursor.lastIndexOf('@' + this.mentionQuery);

    this.mentionCandidates = this.allUsers.filter(user =>
      user.username.toLowerCase().startsWith(this.mentionQuery.toLowerCase())
    );
    this.mentionListVisible = this.mentionCandidates.length > 0;

    console.log("Mention candidates:", this.mentionCandidates);
  } else {
    this.mentionListVisible = false;
  }
}
,

selectMention(username) {
    const textarea = this.$refs.textarea;
  if (!textarea) return;

  var cursorPos = textarea.selectionStart;
  var before = this.newMessage.slice(0, this.mentionInsertIndex);
  var after = this.newMessage.slice(cursorPos);
  this.newMessage = `${before}@${username} ${after}`;
  this.mentionListVisible = false;

  this.$nextTick(() => {
    textarea.selectionStart = textarea.selectionEnd = this.newMessage.length;
    textarea.focus();
  });
},

    async loadMessages() {
      try {
        const { data } = await axios.get('/user/group-messages', {
          headers: {
            'Authorization': 'Bearer ' + this.access_token,
            'Content-Type': 'application/json'
          }
        });
        this.messages = data;
           this.scrollToBottom();
      } catch (error) {
        console.error('Error loading group messages:', error.response || error);
      }
    },

    async sendMessage() {
      try {
        await axios.post('/user/send-group-message', {
          userid: this.userid,
          message: this.newMessage,
        }, {
          headers: {
            'Authorization': 'Bearer ' + this.access_token,
            'Content-Type': 'application/json'
          }
        });

        this.newMessage = '';
        await this.loadMessages();
      } catch (error) {
        console.error('Error sending group message:', error.response || error);
      }
    },

    startMessagePolling() {
      setInterval(() => {
        if (this.chatPopup) {
          this.loadMessages();
        }
      }, 5000); // refresh every 5 seconds
    },


      async loadlan() {



        try {
          const { data} = await  axios.get('/user/loadlan',{
            headers:{
              // 'Authorization':'Bearer '+this.access_token,
              'Content-type': 'application/json',

            }
           });
           console.log(data);

           this.lans = data.lans;

           if(this.languagename === undefined || this.languagename === null){
              this.selectedLanguageName = "Select Language";
            }else{
              this.selectedLanguageName = this.languagename;
            }






        } catch (error) {
          console.log(error.response);
        }
      },





  async selectLanguage(lang) {

console.log(lang.id);

localStorage.setItem('LANGUAGEID', lang.id);
localStorage.setItem('LANGUAGENAME', lang.language_name);
this.selectedLanguageName = lang.language_name;

this.loadlanguage2(lang.id);


},

  async loadlanguage2(id) {

        console.log("lan_id");
   console.log(id);
    try {
      const { data} = await  axios.post('/user/loadlanguage1',{languageid:id},{
        headers:{
          // 'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',

        }
       });
       console.log(data);

       const details = data.details;
       localStorage.setItem('LANGUAGE', JSON.stringify(details))
       window.location.reload();



    } catch (error) {
      console.log(error.response);
    }
  },





      Logout() {
          console.log(this.access_token);
          axios.get('/user/logout',{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',

           }
          }).then(
           response => {

             console.log(response);
          }

          ),
        authService.Logout(this);
        },

      my1(){

      this.$refs.myButton.click()

      },
      my2(){
        if(window.innerWidth > 600){

          this.$refs.myButton2.click()
        }


      },
      my3(){
        if(window.innerWidth > 600){

          this.$refs.myButton3.click()
        }


      },
      my4(){
        if(window.innerWidth > 600){

          this.$refs.myButton4.click()
        }


      },
      my5(){
        if(window.innerWidth > 600){

          this.$refs.myButton5.click()
        }


      },
      my6(){
        if(window.innerWidth > 600){

          this.$refs.myButton6.click()
        }


      },
      my7(){
        if(window.innerWidth > 600){

          this.$refs.myButton7.click()
        }


      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      }
    }
  }

</script>
<style >

.user-item {
  padding: 5px;
  border-bottom: 1px solid #ccc;
  cursor: pointer;
}
.message-bubble {
  background: #f0f0f0;
  border-radius: 10px;
  display: inline-block;
  padding: 6px 12px;
  margin: 4px;
}
.highlight {
  background-color: #ffe58f;
  font-weight: bold;
}
.mention-dropdown {
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  max-height: 150px;
  overflow-y: auto;
  position: absolute;
  z-index: 99;
  width: 200px;
  margin-top: 4px;
}

.mention-item {
  padding: 6px 10px;
  cursor: pointer;
}

.mention-item:hover {
  background-color: #f5f5f5;
}

.bg-primary{
  background-color: white !important;
}

.router2{
  text-decoration: none;
  color: black;
  font-size: large !important;
}
.router2:hover{
  color: white;
}
.router2{
  color: #052950;
}
.b-sidebar{
  width: 250px !important;
}
.mrgin1{
      margin-left: 15px;
}

.clr3:hover{
  background-color: rgb(71, 144, 255)  !important;
  width: 100% !important;
  color: white;
}
.clr3:focus{
  background-color: rgb(71, 144, 255) !important;
  width: 100%;
  color: white  !important;
}
.bodr2{

  padding: 10px;
 

}
.bodr1{

  padding: 5px 20px 5px 20px;
}
   .navbar{
padding-left: 0px !important;
padding-right: 0px !important;
   }

      .menu1{
          color: #0b4687;
          border: 2.5px #0b4687  solid;
          padding: 8px 5px 10px 5px;
          border-radius: 15px;
          margin-left: 5px;
          

        }
        .menu1:hover{
          border: 2px #0b4687  solid;

        }
        .clr1{
          background-color: #AED8F2 !important;
          height:2000px !important;
          margin-left: -10px;

        }

        .bdr3{
         border-top: 2px #E4E5E6  solid;
         padding-bottom: 11px;
        }
        .shadow1 {
        /* border: 1px solid; */
        padding: 10px;
        /* box-shadow: 3px 6px 3px #bdbbbb; */
        }

        .click1:hover{

        background-color: blue;
        }
        .pf1{
          margin-right: 13px;
          margin-top: 3px;
        }
        .logout1{
          margin-right: 10px;
        }
        .pfimg2{

         margin-top: 4px;


        }
        .bel1{
          margin-right: 30px;
          margin-top: 8px;
        }
        .badge1 {
        position: absolute;
        top: -4px;
        right: 3px;
        padding: 1px 5px;
        border-radius: 50%;
        background-color: red;
        color: white;
        font-size: 10px !important;

        }
        .icon1{
          border-radius: 13px;
        }
        .router1{
          text-decoration: none;
        }
        .b-sidebar > .b-sidebar-body {
          background-color: #ffffff6b !important;
        }
        .b-sidebar > .b-sidebar-header {
          background-color: #fafafa6b !important;
          border-top-right-radius: 15px !important;
        }

        .b-sidebar {
          border-top-right-radius: 15px !important;
        }
        .b-sidebar > .b-sidebar-body {
          border-bottom-right-radius: 15px !important;
        }

      .custom-modal-title {
  font-weight: bold;
  cursor: move;
  user-select: none;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.modal-controls {
  display: flex;
  align-items: center;
}

.modal-icon-btn {
  background: transparent;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #666;
 margin-top: -9px;
}



.modal-icon-btn:hover {
  color: #000;
}
.draggable-modal {
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  position: fixed !important;
  margin: 2% !important;
  max-width: 100vw;
  width: 100%;
  height: auto;
}

.top-bar-controls {
  gap: 15px;
}

/* Modal responsiveness */

@media (max-width: 576px) {


  .draggable-modal .modal-content {
   
    border-radius: 0;
    width: 96%;
    

  }
  

 
}
@media (max-width: 768px) {
  /* .top-bar-controls {
    position: absolute;
    top: 0px;
    right: 0px;
    flex-direction: column !important;
    align-items: flex-end;
  } */
     .top-bar-controls {
  
    justify-content: space-between !important;
    flex-wrap: nowrap !important;
    padding: 5px 10px;
  }
  .myboder{
    margin: -0px -10px -5px 0px !important;
  }
  .astylemy{
    margin-bottom: -29px !important;
    
  }
  

  .top-bar-controls img {
    width: 35px !important;
  }

  /* Notification icon smaller */
  #notificationDropdown i {
    font-size: 18px !important;
  }

  /* Adjust badge position on mobile */
 

  /* Language dropdown adapts */
  .language-dropdown {
    padding: 5px 8px !important;
    font-size: 12px !important;
  }

  /* Language icon smaller */
  .language-icon {
    font-size: 16px !important;
    margin-right: 5px;
  }

  /* Logout section smaller */
  .astylemy img {
    width: 25px !important;
  }

  .astylemy span {
    font-size: 10px !important;
  }

  /* Dropdown menus fit screen */
  .dropdown-menu {
    min-width: 180px !important;
    right: 0 !important;
    left: auto !important;
  }
}


.languagbtn{
  
      border: 2.5px solid #0b4687;
      padding-top: 8px;
      border-radius: 15px;
}


  </style>
